var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumbs',{staticClass:"pb-3",attrs:{"text":_vm.name}}),_vm._v(" "),_c('h1',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"body-2 mt-4"},[_c('vue-markdown',{attrs:{"source":_vm.content}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }